// This file should contains all Italian holidays

// Month is 0-based
export const ITALIAN_HOLIDAYS = [
  { month: 0, day: 1 }, // Capodanno
  { month: 0, day: 6 }, // Epifania
  { month: 3, day: 25 }, // Festa della Liberazione
  { month: 4, day: 1 }, // Festa dei Lavoratori
  { month: 5, day: 2 }, // Festa della Repubblica
  { month: 7, day: 15 }, // Ferragosto
  { month: 10, day: 1 }, // Tutti i Santi
  { month: 11, day: 8 }, // Festa dell'Immacolata Concezione
  { month: 11, day: 25 }, // Natale
  { month: 11, day: 26 }, // Santo Stefano
];
